/*
 * Market Share Report - Main Report Page
 *
 * Comprehensive market share analysis feature for internal users.
 * Based on the mobile market share functionality but designed for the web dashboard.
 *
 * Features:
 * - Market share analysis across different drugs and states
 * - Interactive charts and data visualization
 * - Quarterly/yearly analysis periods
 * - Export functionality
 * - State-by-state market penetration analysis
 */

import { Navigate } from 'react-router-dom';
import { useMarketShareReportFeature } from '@shared/feature-flags';
import { MarketShareReport } from '@/features/market-share';

export default function MarketShareReportPage() {
  const isMarketShareReportEnabled = useMarketShareReportFeature();

  if (!isMarketShareReportEnabled) {
    return <Navigate to="/404" replace />;
  }

  return (
    <MarketShareReport
      showDrugSelection={true}
      title="Medicaid Market Share Report"
      description="Select a market basket to view detailed Medicaid utilization insights for tracked drugs, including your products and key competitors. If your organization is looking to track additional drugs, please contact art_capsule@petauri.com."
    />
  );
}
